<template>
  <div
    id="app"
    class="d-flex flex-column h-100"
    :class="{ 'modal-open': hasVisibleModal }"
  >
    <header>
      <div v-if="isLoggedIn" class="m-4 float-right">
        {{ username }} - {{ resellerDisplayName }} |
        <a href="#" @click="logoutAndRedirect()">Logout</a>
      </div>
    </header>

    <main class="container mb-3" v-if="loaded">
      <div class="row">
        <aside class="col-md-6 visible-md visible-lg">
          <nav>
            <ul class="menu">
              <li class="menu-item" v-if="!isLoggedIn">
                <router-link class="nav-link" to="/secure">Account</router-link>
              </li>
              <li class="menu-item" v-if="isAdmin">
                <router-link class="nav-link" to="/secure/resellers"
                  >Resellers</router-link
                >
              </li>
              <li class="menu-item" v-if="isAdmin">
                <router-link class="nav-link" to="/secure/rateplans"
                  >Rateplans</router-link
                >
              </li>
              <li class="menu-item" v-if="isAdmin">
                <router-link class="nav-link" to="/secure/topups-admin"
                  >Top up list (all)</router-link
                >
              </li>
              <li class="menu-item" v-if="isLoggedIn">
                <router-link class="nav-link" to="/secure/topups"
                  >Top up list</router-link
                >
              </li>
              <li class="menu-item" v-if="isLoggedIn">
                <router-link class="nav-link" to="/">Top up</router-link>
              </li>
              <!-- <li class="menu-item">
                <router-link class="nav-link" to="/bundles"
                  >Coverage &amp; bundles</router-link
                >
              </li> -->
            </ul>
          </nav>
        </aside>

        <router-view class="col-md-18" v-if="loaded" />
      </div>
    </main>

    <footer class="footer mt-auto py-3">
      <!-- <ul class="hlist">
        <li>
          <router-link to="/privacy">Privacy Policy</router-link>
        </li>
        <li>
          <router-link to="/terms">Terms &amp; Conditions</router-link>
        </li>
      </ul> -->
    </footer>

    <toast-container></toast-container>
    <div
      class="modal-backdrop fade"
      :class="{ 'd-none': !hasVisibleModal, show: hasVisibleModal }"
    ></div>
  </div>
</template>

<script>
import '@/scss/styles.scss'
import { mapActions, mapGetters } from 'vuex'
import ToastContainer from './components/ToastContainer'

export default {
  components: {
    ToastContainer,
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters(['hasVisibleModal']),
    ...mapGetters('auth', [
      'isLoggedIn',
      'isAdmin',
      'username',
      'resellerDisplayName',
    ]),
  },
  methods: {
    ...mapActions('auth', ['whoami', 'logout']),
    logoutAndRedirect() {
      this.logout().then(() => {
        this.$router.push('/secure')
      })
    },
  },
  created() {
    this.whoami().finally(() => {
      if (this.$route.meta.secure && !this.isLoggedIn) {
        this.$router.push('/secure')
      }

      this.$router.beforeResolve((to, from, next) => {
        if (!to.meta.secure || this.isLoggedIn) {
          next()
        } else {
          next('/secure')
        }
      })
      this.loaded = true
    })
  },
}
</script>

<style lang="scss">
header {
  box-shadow: 2px 0 5px 1px rgba(0, 0, 0, 0.25);
  height: 5em;
  flex: 0 0 5em;
  margin-bottom: 21px;
}

.menu-item {
  margin-bottom: 2px;
  list-style: none;

  a {
    background: #e7f1f8;
    border-radius: 4px;
    color: #0e76bc;

    &.router-link-exact-active {
      font-weight: 700;
    }

    &:hover {
      color: #fff;
      background-color: #0d6dae;
    }
  }
}

footer {
  background: #ddd;

  .hlist {
    list-style: none;
    text-align: center;

    li {
      display: inline-block;
      padding: 0 10px;
    }
    a:hover {
      text-decoration: none;
    }
  }
}
</style>
